module.exports = __webpack_public_path__ + "img/41.d8624aa4.png";